export default {
  courseType: {
    VKU1: "Verkehrskundekurs 1",
    VKU2: "Verkehrskundekurs 2",
    VKU3: "Verkehrskundekurs 3",
    VKU4: "Verkehrskundekurs 4",
    FirstAid: "First Aid Course",
    MotorcycleTraining: "Motorcycle training course",
    DrivingAttendant: "Driving attendant course",
    PGS1: "Grundkurs 1-3",
    PGS2: "Grundkurs 1-3",
    PGS3: "Grundkurs 2a",
    PGS4: "Grundkurs 3"
  },
  shortMonths: {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December"
  },
  daysShort: {
    'monday': 'Mo',
    'tuesday': 'Di',
    'wednesday': 'Mi',
    'thursday': 'Do',
    'friday': 'Fr',
    'saturday': 'Sa',
    'sunday': 'So',
  },
  vkuPriceTitle: {
    bold: 'Price: CHF 260.00',
    note: 'incl. course material'
  },
  pgsPrice: {
    label: 'Course costs:',
    price: 'CHF 210.00',
    note1: 'Basic course 1',
    note2: 'Basic course 2',
    note3: 'Basic course 3'
  },
  vkuNote: {
    note: '(4 course modules) and a voucher worth CHF 40.00 for the mandatory WAB course in Erstfeld, as well as a free TCS membership and TCS traffic legal protection for one year.'
  },
  infoMessage: {
    pgs3: 'This course takes place in groups of the same category. We will be happy to arrange a suitable date in the basic course 1 (or if your LFA expires promptly by phone 079 743 48 12).',
    pgs3_caruso: 'This course takes place in groups of the same category. We will be happy to arrange a suitable date in the basic course 1 (or if your LFA expires promptly by phone 076 621 88 15).',
    pgs3_info: 'Grundkurs 3',
    pgsTitle3Parts: 'Basic course (for motorcycles from 60cc)',
    pgsTitle2Parts: 'Basic course (for all categories)',
    vku1Completed: 'Please note that you must start with VKU 1. Press Cancel if you have not yet completed VKU 1.',
    language: "German",
    languageInfo: 'Language',
    location: "Location",
    instructor: "Instructor",
    enterInfos: "Please enter your contact information",
    whereIsLearnersPermitNumber: "Where is the FABER-PIN?",
    noCoursesTitle: "Technical difficulties",
    noCourses: "Registrations are currently only possible by phone. <br/> Please contact Sven Meier <br/> at <a href='tel:0796773890' style='color: #E91E63; white-space: nowrap;'>079 677 38 90</a>.",
    day: "Day",
    month: "Month",
    year: "Year",
    firstName: "First name",
    lastName: "Last name",
    street: "Street",
    postCode: "Post code",
    city: "City",
    phoneNumber: "Phone",
    email: "Email",
    birthdate: "Birthdate",
    booking: 'Book',
    back: 'Back',
    motorcycleCategory: "Motorcycle License Category",
    continue: "Next",
    learnersPermitNumber: "FABER-PIN",
    requiringInfos: "We just need a little information.",
    byRegistering: "By registering you agree to the",
    termsOfService: "General terms and conditions",
    courseLeft: 'left',
    coursesFree: "places left",
    coursesFree_zero: "Fully booked",
    coursesFree_singular: "place left",
    courseBooked: "Booked",
    signUp: "Register",
    alreadyBooked: 'I have already completed the VKU course',
    alreadyBooked2: 'or would like to register for this part of the course at a later date.',
    pgsPart2and3: `
    If you have completed category A1 before 01.01.2021 and your LFA for category A has a prescribed number of hours of 4, arrange with us a suitable course date for the basic course 3.
    <br/><br/> Ruedi Huwiler
    <br/><a href="mailto:ruedi.huwiler@verkehrsschule.ch" style="color: #E91E63; white-space: nowrap;">ruedi.huwiler@verkehrsschule.ch</a> 
    <br/><a href="tel:+41797434812" style="color: #E91E63; white-space: nowrap;">079 743 48 12</a>
    <br/><br/>Giovanni Caruso
    <br/><a href="mailto:giovanni.caruso@verkehrsschule.ch" style="color: #E91E63; white-space: nowrap;">giovanni.caruso@verkehrsschule.ch</a> 
    <br/><a href="tel:+41766218815" style="color: #E91E63; white-space: nowrap;">076 621 88 15</a>
      <br/><br/>Thank you. We are looking forward to an interesting and instructive course with you.
    `,
    pgsPart2and3Sven: `
    If you have completed category A1 before 01.01.2021 and your LFA for category A has a prescribed number of hours of 4, arrange with us a suitable course date for the basic course 3.
    <br/><br/> Ruedi Huwiler
    <br/><a href="mailto:ruedi.huwiler@verkehrsschule.ch" style="color: #E91E63; white-space: nowrap;">ruedi.huwiler@verkehrsschule.ch</a> 
    <br/><a href="tel:+41797434812" style="color: #E91E63; white-space: nowrap;">079 743 48 12</a>
      <br/><br/>Thank you. We are looking forward to an interesting and instructive course with you.
    `,
    pgsPart2and3Moos: `
    If you have completed category A1 before 01.01.2021 and your LFA for category A has a prescribed number of hours of 4, arrange with us a suitable course date for the basic course 3.
    <br/><br/>Giovanni Caruso
    <br/><a href="mailto:giovanni.caruso@verkehrsschule.ch" style="color: #E91E63; white-space: nowrap;">giovanni.caruso@verkehrsschule.ch</a> 
    <br/><a href="tel:+41766218815" style="color: #E91E63; white-space: nowrap;">076 621 88 15</a>
      <br/><br/>Thank you. We are looking forward to an interesting and instructive course with you.
    `,
    vku: "Have you already completed / booked VKU 1? You must first complete VKU 1 before you can attend to this course.",
    pgs: `
      You don't have the driver's license yet? Please send your contact information to
      <a href="mailto:info@verkehrsschule.ch" style="color: #E91E63;">info@verkehrsschule.ch</a>
      and we will arrange the necessary.
    `
  },
  successMessage: {
    VKUPart1: `
      <h2>Thank you.</h2>
      We received your <strong>reservation</strong> for the
    `,
    VKUPart2: `
      and looking forward to an interesting and instructive course with you. <br>
      <br>
      The course place will be reserved to you until 15 minutes before the course starts. <br>
      <br>
      A confirmation of the reservation will be sent to you by email. If you do not receive a reservation confirmation within one hour, please proceed as follows: Check to see if the email ended up in your spam folder.
      If this is not the case, please contact us using <strong><a href="mailto:info@verkehrsschule.ch">info@verkehrsschule.ch</a></strong>. <br>
      <br>
      With kind regards <br>
      Verkehrsschule Zug <br>
    `,
    FirstAidPart1: `
      <h2>Thank you.</h2>
      We received your <strong>reservation</strong> for the
    `,
    FirstAidPart2: `
      and looking forward to an interesting and instructive course with you. <br>
      <br>
      A confirmation of the registration will be sent to you via postal service. <br>
      <br>
      With kind regards <br>
      Verkehrsschule Zug <br>
    `,
    PGSPart1: `
      <h2>Thank you.</h2>
      We received your <strong>reservation</strong> for the
    `,
    PGSPart2: `
      and looking forward to an interesting and instructive course with you. <br>
      <br>
      A confirmation of the registration will be sent to you via postal service. <br>
      <br>
      With kind regards <br>
      Verkehrsschule Zug <br>
    `
  },
  language: {
    de: 'German',
    en: 'English'
  },
  language_long: {
    de: 'Language: German',
    en: 'Language: English'
  },
  errorMessage: {
    InternalServerError: "Whoops. There was a problem. Please contact info@verkehrsschule.ch",
    200: "Your FABER-PIN was not found",
    201: "Your declared birth date does not match your FABER-PIN.",
    NoIdNumber: "Please enter your FABER-PIN",
    MissingFirstName: "Please enter your firstname",
    MissingLastName: "Please enter your lastname",
    MissingStreet: "Please enter your street",
    MissingPostCode: "Please enter your post code",
    MissingCity: "Please enter your city",
    MissingTel: "Please enter your phone number",
    MissingMail: "Please enter your birthdate",
    MissingBirthdate: "Please enter a valid birthdate",
    202: "Your already added to this course.",
    203: "You have no place in this course.",
    204: "You're already in a course at this date.",
    205: "Your FABER-PIN is invalid at beginning of course.",
    206: "Whoops. There was a problem. Please contact info@verkehrsschule.ch",
    300: "You already have booked a course on this date",
    301: "Please choose a course which starts before your VKU 1.",
    302: "You have already been registered for this course part."
  }
};
